import * as React from 'react';

import { LogEventName, LogLevel } from '../models';
import { IComponentProps } from '../types';
import { uuidOptions } from '../utils';

const uuidv4 = require('uuid/v4');

interface IErrorFallbackProps {
  fallbackUi: React.ReactNode;
  errorId?: string | undefined;
  sessionId?: string | undefined;
}

interface IErrorFallbackState {
  hasError: boolean;
}

type IGraphErrorFallbackProps = IErrorFallbackProps & IComponentProps;

/**
 * Setup error boundary for a React subtree.
 *
 * Any error captured is considered unexpected thus logged. Provide fallbackUi prop
 * to display a alternative UI if error happens. DO NOT attempt to use this as a control flow.
 */
export class ErrorFallbackC extends React.PureComponent<IGraphErrorFallbackProps, IErrorFallbackState> {
  public static getDerivedStateFromError(): IErrorFallbackState {
    return { hasError: true };
  }
  constructor(props: IGraphErrorFallbackProps) {
    super(props);
    this.state = { hasError: false };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    const errorId: string = !!this.props.errorId ? this.props.errorId : uuidv4(uuidOptions());
    if (this.props.callbackHandlers.LogHandler && typeof this.props.callbackHandlers.LogHandler === 'function') {
      const errorMessage = `errorMessage: ${error.message}, stack: ${error.stack}`;
      this.props.callbackHandlers.LogHandler(
        LogEventName.onComponentError,
        LogLevel.Error,
        this.props.sessionId,
        errorMessage
      );
    }
  }

  public render(): React.ReactNode {
    if (this.state.hasError) {
      return this.props.fallbackUi;
    }
    return this.props.children;
  }
}

export const ErrorFallback = ErrorFallbackC;
